















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 4.13.0
 * @changelog 4.13.0 Published.
 */
@Component({
    components: {JdhSneakPeek}
})
export default class JdsDatum extends Vue {
    @Ref() datumEl!: HTMLElement
    @Prop() icon!: string
    hover = false
}
